<script setup lang="ts">
import type { Message } from "@/rvapi";
import { utc2local } from "@/utils";
import { useRouter } from "vue-router";
import { edit, trash_can } from "pn-design-assets/pn-assets/icons";
const props = defineProps<{
  rows: Message[];
  platform: string;
}>();

const emit = defineEmits<{
  (eventName: "delete", id?: string): void;
}>();
const router = useRouter();
const editMessage = (message: Message) => {
  router.push({
    name: "editbroadcast",
    params: {
      id: message.id,
      platform: props.platform,
    },
  });
};
</script>

<template>
  <tr v-for="message in props.rows" :key="message.id">
    <td>{{ utc2local(message.created) }}</td>
    <td>
      <span :class="message.level">{{ message.level }}</span>
    </td>
    <td>{{ utc2local(message.rules?.date?.from) }}</td>
    <td>{{ utc2local(message.rules?.date?.to) }}</td>
    <td>
      {{ message.rules?.version?.from || "" }} -
      {{ message.rules?.version?.to || "" }}
    </td>
    <td>{{ message?.rules?.view?.join(", ") ?? "" }}</td>
    <td>{{ message?.title?.en }}</td>
    <td>
      <pn-button
        appearance="light"
        tooltip="Edit"
        :icon="edit"
        icon-only="true"
        @click="editMessage(message)"
        small="true"
        >Edit</pn-button
      >
      <pn-button
        appearance="warning"
        tooltip="Delete"
        :icon="trash_can"
        icon-only="true"
        @click="emit('delete', message.id)"
        small="true"
        >Delete</pn-button
      >
    </td>
  </tr>
</template>

<style lang="scss" scoped>
pn-button {
  margin-left: 1rem;
}
</style>
